/**
 * Mount jednou v App — registruje themed confirm/prompt pro celou app.
 */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirmDialog } from '../hooks/useConfirmDialog';
import { usePromptDialog } from '../hooks/usePromptDialog';
import {
  registerThemedConfirm,
  registerThemedPrompt,
} from '../lib/themed-dialogs';

export function ThemedDialogsHost() {
  const { t } = useTranslation();
  const confirm = useConfirmDialog();
  const prompt = usePromptDialog();

  useEffect(() => {
    registerThemedConfirm((opts) =>
      confirm.ask({
        confirmLabel: opts.confirmLabel ?? (opts.danger ? t('ui.delete') : t('ui.confirm')),
        cancelLabel: opts.cancelLabel ?? t('ui.cancel'),
        ...opts,
        title: opts.title || t('ui.confirm'),
      })
    );
    registerThemedPrompt((opts) =>
      prompt.ask({
        confirmLabel: opts.confirmLabel ?? t('ui.confirm'),
        cancelLabel: opts.cancelLabel ?? t('ui.cancel'),
        ...opts,
        title: opts.title || t('ui.confirm'),
      })
    );
    return () => {
      registerThemedConfirm(null);
      registerThemedPrompt(null);
    };
  }, [confirm.ask, prompt.ask, t]);

  return (
    <>
      {confirm.dialog}
      {prompt.dialog}
    </>
  );
}
